import React, { useEffect, useReducer, useState } from 'react'
import { Dialog, DialogTrigger } from '@/Components/ui/dialog'
import { Button } from '@/Components/ui/button'
import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'
import WorkflowStateService from '@/Service/WorkflowStateService'
import WorkflowstateColumns from './WorkflowstateColumns'
import CreateworkflowState from '../CreateWorkflowState'

const WorkflowState = () => {
    const { userInfo } = useAuth()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalWorkflowState: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        deleteId: [],
        allcheck: false,
        workflowState: [],
        WorkflowStateSearch: '',
        isOpen: false,
        queryParam: {
            page: 1,
            state: '',
        },
    })
    const [debouncedWorkflowStateValue] = useDebounce(event.WorkflowStateSearch, Constant.DEBOUNCE_DELAY)
    const location = useLocation()

    const getWorkflowState = async () => {
        updateEvent({ isDataFetching: true, workflowState: [] })
        try {
            const resp = await WorkflowStateService.getWorkflowState(event.queryParam)
            if (resp.data.success) {
                updateEvent({ workflowState: resp.data.data, totalWorkflowState: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getWorkflowState()
    }, [event.queryParam.page, event.queryParam.state])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                state: debouncedWorkflowStateValue,
            },
        })
    }, [debouncedWorkflowStateValue])

    const deleteWorkflowState = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })

            return false
        }
        try {
            const resp = await WorkflowStateService.deleteWorkflowState(event.deleteId)
            if (resp.data.success) {
                getWorkflowState()
            }

            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {}
        updateEvent({ deleteConfirmationOpen: false })
    }

    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                        <Dialog open={event.isOpen} onOpenChange={() => updateEvent({ isOpen: !event.isOpen })}>
                            <DialogTrigger>
                                <Button className="bg-primary-btn hover:bg-primary-purpal">
                                    <SquarePlus />
                                    Add State
                                </Button>
                            </DialogTrigger>
                            <DialogTrigger></DialogTrigger>
                            <CreateworkflowState getWorkflowState={getWorkflowState} setIsOpen={(isOepn) => updateEvent({ isOpen: isOepn })} />
                        </Dialog>
                    )}

                    {checkPermission(RequiredPermission.PROCESS.DELETE, userInfo.roles) && event.deleteId.length > 0 && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deleteWorkflowState}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.WorkflowStateSearch}
                        onChange={(e) => updateEvent({ WorkflowStateSearch: e.target.value })}
                        placeholder="State"
                    />
                </div>
                <Datatable
                    columns={WorkflowstateColumns()}
                    data={event.workflowState}
                    totalDataCount={event.totalWorkflowState}
                    allcheck={event.allcheck}
                    updateEvent={updateEvent}
                    deleteId={event.deleteId}
                    loading={event.isDataFetching}
                />
            </BodyCard>
        </>
    )
}

export default WorkflowState
